import { render, staticRenderFns } from "./GoodsClass.vue?vue&type=template&id=d74286c8&scoped=true"
import script from "./GoodsClass.vue?vue&type=script&lang=js"
export * from "./GoodsClass.vue?vue&type=script&lang=js"
import style0 from "./GoodsClass.vue?vue&type=style&index=0&id=d74286c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74286c8",
  null
  
)

export default component.exports